const ChangeSleeveSolutions: string[] = [
    'Sleeve change to vented',
    'Sleeve change to closed',
];

export function isChangeSleeveSolution(solutionName: string): boolean {
    return ChangeSleeveSolutions.includes(solutionName);
}
